var $81dab28f37f59d1a$exports = {};
$81dab28f37f59d1a$exports = {
  "decrease": function decrease(args) {
    return "".concat(args.fieldLabel, " cs\xF6kkent\xE9se");
  },
  "increase": function increase(args) {
    return "".concat(args.fieldLabel, " n\xF6vel\xE9se");
  },
  "numberField": "Sz\xE1mmez\u0151"
};
export { $81dab28f37f59d1a$exports as default };